import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import {
  Table,
  Td,
  Tr,
  Th,
  Tbody,
  Thead,
  Tfoot,
  Box,
} from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination"; // Import Pagination component
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";

const InvoiceGstInfo = ({ selectedItem }) => {
  const [totalAmount, setTotalAmount] = useState({
    bsAmt: 0,
    currentItems: 0,
    s: 0,
    i: 0,
    gst: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // Set the number of items per page

  useEffect(() => {
    const gstRc = selectedItem?.gstRc;
    if (gstRc && gstRc.length > 0) {
      const totals = gstRc.reduce(
        (acc, item) => {
          const { bsAmt, amt } = item;
          const { s, i, c } = amt;

          acc.bsAmt += parseFloat(bsAmt || 0);
          acc.c += parseFloat(c || 0);
          acc.s += parseFloat(s || 0);
          acc.i += parseFloat(i || 0);

          return acc;
        },
        {
          bsAmt: 0,
          c: 0,
          s: 0,
          i: 0,
        }
      );

      totals.gst = totals.c + totals.s + totals.i;
      setTotalAmount(totals);
    }
  }, [selectedItem]);

  // Calculate pagination details
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = selectedItem?.gstRc?.slice(indexOfFirstItem, indexOfLastItem) || [];
  const pageCount = Math.ceil((selectedItem?.gstRc?.length || 0) / itemsPerPage);

  return (
    <>
      <Row className="info-row">
        <Col className="check-cross-mark mt-0">
          <Form.Label>
            <span
              className={
                currentItems.length
                  ? "checkmark"
                  : "crossmark"
              }
            ></span>{" "}
            Is GST applicable?
          </Form.Label>
        </Col>
      </Row>
      {currentItems.length ? (
        <div className="info-table">
          <Box overflowX="auto">
            <Table size="md" className="table-info" variant="striped">
              <Thead>
                <Tr>
                  <Th>No.</Th>
                  <Th>Base Amount</Th>
                  <Th>GST (%)</Th>
                  <Th>IGST</Th>
                  <Th>SGST</Th>
                  <Th>CGST</Th>
                  <Th>Total GST</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((item, index) => {
                  const { bsAmt,prc, amt } = item;
                  const { s, i, c } = amt;
                  const totalGst = parseFloat(s || 0) + parseFloat(i || 0) + parseFloat(c || 0);
                  return (
                    <Tr key={index}>
                      <Td>{indexOfFirstItem + index + 1}</Td>
                      <Td>
                        <span className="rupee-symbol">₹</span>{" "}
                        {bsAmt ? formatAmountIndianRupees(Number(bsAmt)) : Number(0).toFixed(2)}
                      </Td>
                      <Td>{prc || "-"}</Td>
                      <Td>
                        <span className="rupee-symbol">₹</span>{" "}
                        {i ? formatAmountIndianRupees(Number(i)) : Number(0).toFixed(2)}
                      </Td>
                      <Td>
                        <span className="rupee-symbol">₹</span>{" "}
                        {s ? formatAmountIndianRupees(Number(s)) : Number(0).toFixed(2)}
                      </Td>
                      <Td>
                        <span className="rupee-symbol">₹</span>{" "}
                        {c ? formatAmountIndianRupees(Number(c)) : Number(0).toFixed(2)}
                      </Td>
                      <Td>
                        <span className="rupee-symbol">₹</span>{" "}
                        {totalGst ? formatAmountIndianRupees(Number(totalGst)) : Number(0).toFixed(2)}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Th colSpan={1}>Total</Th>
                  <Td colSpan={1}>
                    {/* <span className="rupee-symbol">₹</span>{" "} */}
                    {formatAmountInINR(totalAmount?.bsAmt || 0)}
                  </Td>
                  
                  <Td></Td>
                  <Td colSpan={1}>
                    {/* <span className="rupee-symbol">₹</span>{" "} */}
                    {formatAmountInINR(totalAmount?.i || 0)}
                  </Td>
                  <Td colSpan={1}>
                    {/* <span className="rupee-symbol">₹</span>{" "} */}
                    {formatAmountInINR(totalAmount?.s || 0)}
                  </Td>
                  <Td colSpan={1}>
                    {/* <span className="rupee-symbol">₹</span>{" "} */}
                    {formatAmountInINR(totalAmount?.c || 0)}
                  </Td>
                  <Td colSpan={1}>
                    {/* <span className="rupee-symbol">₹</span>{" "} */}
                    {formatAmountInINR(totalAmount?.gst || 0)}
                  </Td>
                </Tr>
              </Tfoot>
            </Table>
          </Box>

          {/* Pagination Component */}
          <Pagination className="justify-content-end" style={{ marginTop: '20px' }}>
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {Array.from({ length: pageCount }, (_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, pageCount))}
              disabled={currentPage === pageCount}
            />
          </Pagination>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default InvoiceGstInfo;
